import React, { ReactNode } from 'react'
import { useNavigate } from 'react-router'
import { useSelectContext } from './SelectContext'

const Option: React.FC<{
  children: ReactNode | ReactNode[]
  value: string
  link: string
}> = ({ children, value, link }) => {
  const { changeSelectedOption } = useSelectContext()
  const navigate = useNavigate()

  return (
    <li
      className="select-option"
      onClick={() => {
        changeSelectedOption(value)
        navigate(`/${link}`)
      }}
    >
      {children}
    </li>
  )
}

export default Option
